import React from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SortButtons } from '../../../../shared/components/buttons';
import { entityListStore } from '../../../stores/entityListStore';
import { ListMode, LIST_MODE } from '../NgzEntityList.settings';

type TitleRowProps = {
  listMode: ListMode;
};

const TitleRow = observer(({ listMode }: TitleRowProps) => {
  const { filterMethods } = entityListStore;
  const { handleSort, getIsSortedBy } = filterMethods;

  return (
    <GridTableRow variant="header" dataTestId="header-row">
      <GridTableCell dataTestId="business-name-cell">
        <SortButtons
          fieldName="BUSINESS_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Entity Name
        </SortButtons>
      </GridTableCell>
      <GridTableCell>InBody</GridTableCell>
      <GridTableCell dataTestId="owner-name-cell">
        <SortButtons
          fieldName="OWNER_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Owner name
        </SortButtons>
      </GridTableCell>
      <GridTableCell>Status</GridTableCell>
      <GridTableCell dataTestId="registration-date-cell">
        <SortButtons
          fieldName="REGISTRATION_DATE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Start Date
        </SortButtons>
      </GridTableCell>
      {listMode === LIST_MODE.NUTRITION && (
        <GridTableCell dataTestId="active-customer-count-cell">
          <SortButtons
            fieldName="ACTIVE_NUTRITION_CUSTOMER_COUNT"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            Active Customers
          </SortButtons>
        </GridTableCell>
      )}
      {listMode === LIST_MODE.SCAN_IQ && (
        <GridTableCell dataTestId="active-customer-count-cell">
          <SortButtons
            fieldName="ACTIVE_SCAN_IQ_CUSTOMER_COUNT"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            Active Customers
          </SortButtons>
        </GridTableCell>
      )}
      <div />
    </GridTableRow>
  );
});

export { TitleRow };
